
import DownloadIcon from '@/assets/svg/icons/download.svg';
import Vue from 'vue';
import { getDownloadUrl } from '@/utility/helpers';

export default Vue.extend({
  props: {
    variant: {
      type: String,
      default: 'default',
    },
    headline: {
      type: String,
    },
    link: {
      type: Object,
    },
    fileSize: {
      type: Number,
    },
    noIndex: {
      type: Boolean,
    },
  },
  components: { DownloadIcon },
  data() {
    return {
      getDownloadUrl,
    };
  },
  methods: {
    getFileName() {
      if (!this.link?.filename) {
        return;
      }
      const fileName = this.link.filename.split('/')[7].split('.')[0];
      return fileName.charAt(0).toUpperCase() + fileName.slice(1);
    },
    getFileFormat(linkObject: any) {
      if (!linkObject.filename) {
        return;
      }
      const fileType = linkObject.filename.split('/')[7].split('.')[1].toUpperCase();
      return fileType;
    },
  },
});
